// extracted by mini-css-extract-plugin
module.exports = {"group":"styles_group__rtbRC","fluid":"styles_fluid__LC74V","color":"styles_color__s4sVG","disabled":"styles_disabled__uHmx7"};